import { createContext, useContext } from 'react';
import { useParams } from 'react-router';
import { BLOG_LANGS, BlogLangType } from '../../types/blogTypes';

export type BlogContextType = {
    lang?: BlogLangType;
    category?: string;
    slug?: string;
};

export const BlogContext = createContext<BlogContextType | null>(null);

export const BlogProvider = ({ children }: { children: React.ReactNode }) => {
    const { lang, category, slug } = useParams();

    const isValidLang = BLOG_LANGS.includes(lang as BlogLangType);
    if (!isValidLang) {
        return null;
    }

    return (
        <BlogContext.Provider value={{ lang: lang as BlogLangType, category, slug }}>
            {children}
        </BlogContext.Provider>
    );
};

export const useBlogContext = () => {
    const context = useContext(BlogContext);

    const isValidLang = BLOG_LANGS.includes(context?.lang as BlogLangType);
    if (!context || !isValidLang) {
        return {} as BlogContextType;
    }

    return context;
};
